import type { ProductPriceSetting } from '@components/ProductPrice';
import { useProductItemThemeSettings } from '@providers/ThemeProvider/Provider/ProductItemThemeSettings';
import { useMemo } from 'react';

export type ProductPricePropsMapSettings = Pick<
  ProductPriceSetting,
  'showCentAsSuperscript' | 'showMultiVariantPrice' | 'showSavingDisplay' | 'compareAtPricePosition'
>;

export const useConnectProductPrice = () => {
  const settings = useProductItemThemeSettings();
  const productPriceSettings = settings.productInfo?.elements?.price;
  const textAlign = settings.productInfo?.textAlign;

  const props: ProductPricePropsMapSettings = useMemo(() => {
    if (!productPriceSettings) return {};

    const {
      priceColor,
      priceFontFamily,
      priceFontStyle,
      priceFontWeight,
      priceFontSize,
      salePriceColor,
      salePriceFontFamily,
      salePriceFontStyle,
      salePriceFontWeight,
      salePriceFontSize,
      compareAtPriceColor,
      compareAtPriceFontFamily,
      compareAtPriceFontStyle,
      compareAtPriceFontWeight,
      compareAtPriceFontSize,
      savingDisplayColor,
      ...rest
    } = productPriceSettings;

    return {
      ...rest,
      priceStyle: {
        color: priceColor,
        fontFamily: priceFontFamily,
        fontStyle: priceFontStyle,
        fontWeight: priceFontWeight,
        fontSize: priceFontSize,
      },
      salePriceStyle: {
        color: salePriceColor,
        fontFamily: salePriceFontFamily,
        fontStyle: salePriceFontStyle,
        fontWeight: salePriceFontWeight,
        fontSize: salePriceFontSize,
      },
      comparePriceStyle: {
        color: compareAtPriceColor,
        fontFamily: compareAtPriceFontFamily,
        fontStyle: compareAtPriceFontStyle,
        fontWeight: compareAtPriceFontWeight,
        fontSize: compareAtPriceFontSize,
      },
      savingStyle: {
        color: savingDisplayColor,
      },
      textAlign,
    };
  }, [productPriceSettings, textAlign]);

  return {
    props,
  };
};
